import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Flex, Input, Spinner, Text, Paragraph } from "theme-ui";
import theme from "../../../theme";
import { useSelector } from "react-redux";
import { OtpVerifyValues } from "../../../../@types";
import { useDispatch } from "react-redux";
import { ActionCreateByUrl } from "../../../store/actions/CommonAction";
import { useState } from "react";

// Validation schema for OTP input
const validationSchema = Yup.object({
    otp: Yup.string()
        .length(6, "OTP must be 6 digits")
        .required("OTP is required"),
});

const VerifyOtp = () => {
    const navigate = useNavigate();
    const loader = useSelector((state: any) => state.auth.loader);
    const location = useLocation();
    const dispatch = useDispatch();
    const email = location.state?.email || '';
    const receivedotp = location.state?.otp || '';
    const [otp, setOtp] = useState<string>(receivedotp);
    // Formik form setup for OTP input
    const Formik = useFormik<OtpVerifyValues>({
        initialValues: {
            email,
            otp: '',
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const payload = {
                email,
                otp: values.otp || "",
            };
            dispatch(ActionCreateByUrl({ Query: "/otp/verify-otp", obj: payload }, (res: any) => {
                if (res.status) {
                    navigate('/display-project-status')
                }
            }))

        },
    });
    const { handleSubmit, setFieldValue, values, touched, errors } = Formik;
    const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let value = e.target.value.replace(/\D/g, "").slice(-1); // Only allow numbers
        let otpArray = values.otp.split("");

        otpArray[index] = value || "";
        const newOtp = otpArray.join("");
        setOtp(newOtp);
        setFieldValue("otp", newOtp);

        // Move to next input if typing
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`)?.focus();
        }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        let pastedData = e.clipboardData.getData("Text").replace(/\D/g, "");

        if (pastedData.length === 6) {
            setOtp(pastedData);
            setFieldValue("otp", pastedData);
        } else {
            let otpArray = values.otp.split("");
            pastedData.split("").forEach((char, index) => {
                if (index < 6) otpArray[index] = char;
            });
            const newOtp = otpArray.join("");
            setOtp(newOtp);
            setFieldValue("otp", newOtp);
        }
    };

    return (
        <Flex sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '90vh', background: '#E0F7FA' }}>
            <Box sx={{ width: ['90%', '70%', '40%'], mt: 6, gap: "23px", background: 'white', padding: 4, borderRadius: '8px' }}>
                <Text sx={{ fontSize: '24px', fontWeight: '600', mb: 3 }}>OTP Verification</Text>
                <Paragraph sx={{ fontSize: '16px', color: '#555' }}>Enter OTP sent to your registered email</Paragraph>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Box mb={3} sx={{ display: 'flex', gap: 2 }}>
                        {[...Array(6)].map((_, index) => (
                            <Input
                                key={index}
                                id={`otp-${index}`}
                                type="text"
                                name="otp"
                                maxLength={1}
                                value={values.otp?.[index] || ""}
                                onChange={(e) => handleOtpChange(e, index)}
                                onPaste={handlePaste}
                                sx={{
                                    width: "40px",
                                    height: "40px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#F1F1F1",
                                    ":focus": {
                                        borderColor: theme.colors?.primary,
                                    },
                                }}
                            />
                        ))}
                    </Box>

                    {touched.otp && errors.otp && (
                        <Text sx={{ color: `${theme?.colors?.red}`, mt: 1 }}>{errors.otp}</Text>
                    )}

                    <Button
                        type="submit"
                        sx={{
                            width: '100%',
                            bg: `${theme.colors?.primary}`,
                            color: `${theme?.colors?.white}`,
                            py: 2,
                            borderRadius: '4px',
                            cursor: 'pointer',
                            mt: 3,
                        }}
                    >
                        {loader ? (
                            <Spinner sx={{ color: theme.colors?.background, width: 3, p: 0, m: 0 }} />
                        ) : (
                            "Verify & Proceed"
                        )}
                    </Button>

                    {/* <Text sx={{ mt: 2 }}>
                        Didn't receive OTP?{" "}
                        <Link href="#" sx={{ color: theme.colors?.primary }}>Resend Code</Link>
                    </Text> */}
                </form>
            </Box>
        </Flex>
    );
};

export default VerifyOtp;
